@if (feature) {
    <div [innerHTML]="feature.text | trustHtml"></div>
}